// extracted by mini-css-extract-plugin
export default {"toggle-button":"ToggleButton_toggle-button__5VyGK","active":"ToggleButton_active__fcHMx","span-switch-icon":"ToggleButton_span-switch-icon__8P9F1"};